import { useTranslation } from 'react-i18next';
import { useTitle } from 'react-use';

import {
  useNavigationAnalytics,
  useGeneralPreformanceCheckAnalytics,
} from './hooks';

import type { FC, PropsWithChildren as AppProps } from 'react';

export const App: FC<AppProps> = ({ children }) => {
  const { t } = useTranslation();
  useTitle(t('app.title'));
  useNavigationAnalytics();
  useGeneralPreformanceCheckAnalytics();

  return <>{children}</>;
};
